import { RestServiceConnection } from "../RestServiceConnection";
import QueryString from "qs" ;

export class DocumentService extends RestServiceConnection{

    renderDocument = async (documentId?: string|null, url?: string|null): Promise<Blob|null> => {
        
        if(documentId === undefined) {
            return null;
        }

        if(documentId === null) {
            return null;
        }
        
        await this.makeRequest({
            method: "get",
            responseType: "blob",
            url: `/document/render/${documentId}`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
        });

        return this.response?.data
    }

    downloadFile = async(typeFile: string, filter?: any): Promise<Blob> => {
        try {
            const hasImages = !!(filter && filter.filter_filters && filter.filter_filters.export_images);
            try {
                const keys = hasImages ? Object.keys(filter.filter_filters.export_images || {}) : [];
                console.log('[Export] DocumentService.downloadFile', typeFile, 'hasImages:', hasImages, 'keys:', keys)
            } catch {}
            if (hasImages) {
                try {
                    const imgs = filter.filter_filters.export_images || {};
                    console.log('[Export] POST payload image lens:', {
                        geo_map: imgs.geo_map ? imgs.geo_map.length : 0,
                        specialties_pie: imgs.specialties_pie ? imgs.specialties_pie.length : 0
                    })
                } catch {}
                await this.makeRequest({
                    withCredentials: true,
                    method: "post",
                    responseType: "blob",
                    url: `/metric-data-export/${typeFile}`,
                    data: filter,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
            } else {
                await this.makeRequest({
                    withCredentials: true,
                    method: "get",
                    responseType: "blob",
                    url: `/metric-data-export/${typeFile}`,
                    params: filter,
                    paramsSerializer: {
                        serialize: (params: any) => QueryString.stringify(params) ,
                    }
                });
            }
            if (this.response !== null) {
                try {
                    console.log('[Export] DocumentService response status:', this.response?.status || 200)
                } catch {}
                return this.response?.data 
            } else {
                throw new Error('Error download file');
            }
        } catch (error) {
            throw new Error('Error download file');
        }
    }

}
